import React from "react";
import AdminLayout from "./AdminLayout";
import { Box, Typography } from "@mui/material";

const AdminsPage = () => {
  return (
    <AdminLayout>
      <Box>
        <Typography variant="h4" sx={{ mb: 3, fontWeight: 600 }}>
          Admin Management
        </Typography>
        {/* Copy your renderAdminManagement() content from AdminDashboard.js here */}
        <Typography variant="body1" color="text.secondary">
          Admin management content - move from AdminDashboard.js
        </Typography>
      </Box>
    </AdminLayout>
  );
};

export default AdminsPage;
